<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ce8oyx/tc-custom/9781614233367.jpg?1705766127353" alt="This image is the cover for the book Cape Cod Murder of 1899"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cape Cod Murder of 1899
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The story of a teenage thief who became a killer—and how prison transformed him—in turn-of-the-century New England.</b><br/>  <br/> On a crisp September evening in 1899, a seventeen-year-old petty thief named Edwin Ray Snow shot and killed a bakery deliveryman named Jimmy Whittemore outside Yarmouth, Massachusetts. The gunshots rang out for only a moment, but the effects resounded on Cape Cod for half a century.<br/>  <br/> The idyllic atmosphere of turn-of-the-century Cape Cod was shattered in a flash. Soon after the crime, Snow pleaded guilty to murder in the first degree, and was the first person ever to be sentenced to death by electric chair in the state’s history. But his compelling story didn’t end there, and his redemption—earned through decades of hard time—was as dramatic and uplifting as his crime was heinous.<br/>  <br/> Drawing upon town records, historical documents, correspondence and newspapers of the day, <i>The Cape Cod Murder of 1899</i> recreates the towns of Dennis and Yarmouth at the turn of the century and examines the details of a murder that shook Cape Cod to its core.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Theresa Mitchell Barbo
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0e63b327